import { path, shareDocument } from "../../constants/path";
import instance from "../../services/http";
import { getHeader, setandgetCookies } from "../../utils/utils";
// import { getAuthHeader, getHeader } from "../../utils/utils";

let sharedAbortController = new AbortController();

export async function getSiteData(_siteKey) {
  const header = getHeader();
  const response = await instance.get(
    `${path.GET_SITE_DATA}/${_siteKey}`,
    header
  );
  return response;
}

export async function getLabelData(slug) {
  const header = getHeader();
  const response = await instance.get(
    `${path.LABEL_DATA}?project_slug=${slug}`,
    header
  );
  return response;
}

export async function getConversationData(_siteKey) {
  const header = getHeader();
  const response = await instance.get(
    `${path.GET_CONVERSATIONS_DATA}/${_siteKey}`,
    header
  );
  return response;
}

export async function getDocumentsAndLabels(slug) {
  const headers = getHeader();
  const response = await instance.get(
    `${path.GET_INVITE_ONLY_USERS_DOCUMENT_LABELS + slug}`,
    headers
  );
  return response;
}

export async function getParticularConversationData(_conversationId) {
  const header = getHeader();
  const response = await instance.get(
    `${path.GET_PARTICULAR_CONVERSATION_DATA}/${_conversationId}`,
    { ...header }
  );
  return response;
}

export async function updateConversationData(_data) {
  const header = getHeader();
  const { conversationId } = _data;
  const response = await instance.patch(
    `${path.UPDATE_PARTICULAR_CONVERSATION_DATA}/${conversationId}`,
    _data,
    header
  );
  return response;
}

export async function clearAllConversationsData(_siteKey) {
  const header = getHeader();
  const response = await instance.delete(
    `${path.CLEAR_ALL_CONVERSATIONS_DATA}/${_siteKey}`,
    header
  );
  return response;
}

export async function clearParticularConversationData(_conversationId) {
  const header = getHeader();
  const response = await instance.delete(
    `${path.CLEAR_PARTICULAR_CONVERSATION_DATA}/${_conversationId}`,
    header
  );
  return response;
}

export async function sendQuestionData(_data, projectName) {
  const header = getHeader();

  const response = await instance.post(
    path.SEND_QUESTION_DATA,
    _data,
    { ...header, signal: sharedAbortController.signal }
  );
  return response;
}

export async function sendReactionValueData(questionId, selectedAnswer) {
  const header = getHeader();
  const response = await instance.patch(
    `${path.SEND_USER_REACTION}/${questionId}/${selectedAnswer}`,
    {},
    header
  );
  return response;
}

export async function sendShareDocumentSettingsData(_settingsData, _siteKey) {
  const headers = getHeader();
  headers.device_id = new Date().getTime();
  const response = await instance.put(
    shareDocument.SHARE_DOCUMENT_SETTINGS + _siteKey,
    { project_setting: _settingsData },
    headers
  );
  return response;
}

export async function shareAccessToggleData(
  _accessibleToggleValue,
  uuid,
  password,
  token_expires_at,
  jwt_token
) {
  const headers = getHeader();
  const response = await instance.patch(
    shareDocument.SEND_SHARE_ACCESS_TOGGLE_VALUE + uuid,
    {
      is_public: _accessibleToggleValue,
      password: password,
      jwt_token: jwt_token,
      token_expires_at: token_expires_at,
    },
    headers
  );
  return response;
}

export async function resetSiteData(_siteKey, _threadid) {
  const headers = getHeader();
  const response = await instance.delete(
    `${path.RESET_SITE_DATA}conversations/destroy/${_siteKey}/${_threadid}`,
    headers
  );
  return response;
}

export async function inviteOnlyAPI(_data) {
  const header = getHeader();
  const response = await instance.post(
    shareDocument.INVITE_ONLY,
    _data,
    header
  );
  return response;
}

// Create a function to cancel the sendQuestionData request
export function cancelSendQuestionData() {
  sharedAbortController.abort();
  // Re-intializing abort controller
  sharedAbortController = new AbortController();
}
